import React from 'react';
import './Header.css';
import { images } from '../../constants';
import { SubHeading } from '../../components';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  const handleExploreMenu = () => {
    navigate('/menu-list');
  };

  return (
    <div className='app__header app__wrapper section__padding' id='home'>
      <div className="app__wrapper_info">
        <SubHeading title="Diversity in the taste within Australia" />
        <h1 className="app__header-h1">
          The key to authentic <br /> Sri Lankan dining.
        </h1>
        <p className="p__opensans" style={{ margin: "2rem 0" }}>
          We’re proud to be part of Sydney’s multicultural food scene, offering a warm, family-friendly atmosphere where everyone is welcome whether you're discovering Sri Lankan cuisine for the first time or looking for a taste of home.
        </p>
        <button className="custom__button" type="button" onClick={handleExploreMenu}>
          Explore Menu
        </button>
      </div>
      
      <div className="app__wrapper_img">
        <img src={images.welcome} alt="welcome" />
      </div>
    </div>
  );
};

export default Header;

